import { IDataChart } from '@/creditflowresearch/domain/vo/Bond/IDataChart';
import { SectorGrouping } from '@/creditflowresearch/application/Bonds/charts/constants';
import { initColors } from '@/creditflowresearch/application/Bonds/charts/helpers';

interface ITransformChartDataOptions {
  isSector: boolean,
  groupBy: SectorGrouping | undefined,
}

// Mutates the fresh RPC response before it's cached; never call it on `useQuery` data.
export const transformChartData = (
  data: IDataChart[],
  { isSector, groupBy }: ITransformChartDataOptions,
): IDataChart[] => {
  if (!isSector) {
    initColors(data);
  }

  if (groupBy === SectorGrouping.SUB_SECTOR) {
    const other = data.find((item) => item.name === 'Other');

    if (other) {
      other.name = 'Other Subsectors';
    }
  }

  return data;
};
